import classNames from 'classnames';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import React, { Fragment, useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import EcoGraphicSwiperItem from './eco-graphic-swiper-item';
import './index.scss';
import { EcoGraphicSwiperItemProps, EcoGraphicSwiperProps } from './props';

/**
 * 多栏图片(标题 + 描述)
 */
const EcoGraphicSwiper: React.FC<EcoGraphicSwiperProps> = ({ imgHeight = '1-1', layout = 'swiper', uiType = 'ui6', items = [], className, ...reset }) => {
    const props = reset || {};
    const prefixCls = `eco-graphic-swiper`;
    const theme = props.theme || 'white';
    const length = items.length;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-length-${length}`]: length,
        [`${prefixCls}-imgHeight-${imgHeight}`]: imgHeight,
        [`${prefixCls}-uiType-${uiType}`]: uiType,
    });
    const [spaceBetweenW, setSpaceBetweenW] = useState(24); //左右间隔
    useEffect(() => {
        const initHandle = () => {
            // 初始化间隔
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenW(24);
            } else {
                setSpaceBetweenW(16);
            }
        };
        initHandle();
    }, []);
    return (
        <div className={classes}>
            {layout === 'spread' && (
                <div className={`${prefixCls}-spread`}>
                    {items.map((item: EcoGraphicSwiperItemProps, index: number) => {
                        return (
                            <Fragment key={index}>
                                <EcoGraphicSwiperItem {...item} />
                            </Fragment>
                        );
                    })}
                </div>
            )}
            {layout === 'swiper' && (
                <Swiper
                    className={`${prefixCls}-swiper`}
                    slidesPerView={'auto'}
                    spaceBetween={spaceBetweenW}
                    navigation={{
                        nextEl: '.eco-swiper-button-next',
                        prevEl: '.eco-swiper-button-prev',
                    }}
                    modules={[Navigation]}
                >
                    {items.map((item: EcoGraphicSwiperItemProps, index: number) => {
                        return (
                            <SwiperSlide key={index} className={`${prefixCls}-swiper-item`}>
                                <EcoGraphicSwiperItem {...item} />
                            </SwiperSlide>
                        );
                    })}
                    <div className={`eco-swiper-control eco-swiper-control-${theme}`}>
                        <div className="eco-swiper-navigation">
                            <div className="eco-swiper-button-prev">
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                            <div className="eco-swiper-button-next">
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                        </div>
                    </div>
                </Swiper>
            )}
        </div>
    );
};

export default EcoGraphicSwiper;
